import { render, staticRenderFns } from "./ChooseMembers.vue?vue&type=template&id=820ff7e2&"
import script from "./ChooseMembers.vue?vue&type=script&lang=js&"
export * from "./ChooseMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports